var _path, _path2, _path3, _path4, _g, _path5;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMessageSent(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ffeea3",
    d: "M1.5 5.5H28.5V24.5H1.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ba9b48",
    d: "M28,6v18H2V6H28 M29,5H1v20h28V5L29,5z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffeea3",
    d: "M1.5,9.8L13.1,16c1.2,0.6,2.6,0.6,3.8,0l11.6-6.2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#ba9b48",
    d: "M15,17c-0.7,0-1.5-0.2-2.1-0.5L1.3,10.2l0.5-0.9l11.6,6.2c1,0.6,2.3,0.6,3.3,0l11.6-6.2l0.5,0.9 l-11.6,6.2C16.5,16.8,15.7,17,15,17z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#bae0bd",
    d: "M23 16.5A6.5 6.5 0 1 0 23 29.5A6.5 6.5 0 1 0 23 16.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5e9c76",
    d: "M23,17c3.3,0,6,2.7,6,6s-2.7,6-6,6s-6-2.7-6-6S19.7,17,23,17 M23,16c-3.9,0-7,3.1-7,7s3.1,7,7,7 s7-3.1,7-7S26.9,16,23,16L23,16z"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M21.9 26.6L19 23.7 20.5 22.3 21.9 23.8 26 19.6 27.5 21z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageSent);
export default __webpack_public_path__ + "static/media/message--sent.c09664d3e65a805404630d99ab4643f4.svg";
export { ForwardRef as ReactComponent };